import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const EngineNo = (props) => {
  return (
    <FormGroup controlId="engineNo">
      <Col componentClass={ControlLabel} sm={5}>
        Engine Number **
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.engineNo} onChange={props.handleChangeEngineNo}
            autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

EngineNo.propTypes = {
  engineNo: PropTypes.string,
  handleChangeEngineNo: PropTypes.func
};

export default EngineNo;



// WEBPACK FOOTER //
// ./src/app/components/engineNo/EngineNo.js